import { render, staticRenderFns } from "./TaskSettingDialog.vue?vue&type=template&id=38c07ff6&scoped=true&"
import script from "./TaskSettingDialog.vue?vue&type=script&lang=js&"
export * from "./TaskSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettingDialog.vue?vue&type=style&index=0&id=38c07ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c07ff6",
  null
  
)

export default component.exports